import { useQuery } from '@tanstack/react-query';
import { businessAccessApi } from '../api/businessAccessClient';

// SAM-1293 — the payment of ONE pass, as GET /business_access/{id} answers it for staff: `payment` (the latest charge:
// status, amount, currency, gateway, date; no references, no card) and `payment_link` (the state of its link). The
// tenant Front Desk and the estate group roles read it from here, never from the business's payments ledger (403).

export interface PassPaymentFacts {
  payment_status?: string | null;
  payment_amount?: number | null;
  currency?: string | null;
  payment_gateway?: string | null;
  payment_date?: string | null;
}

export interface PassPaymentLinkFacts {
  status?: string | null;
  expires_at?: string | null;
  paid_at?: string | null;
}

export interface PassPayment {
  payment: PassPaymentFacts | null;
  payment_link: PassPaymentLinkFacts | null;
}

/** The one record out of the body (`{ data: [row] }`, `{ data: row }` or the 404 stand-in `{ data: [] }`). */
type PassRecord = { payment?: PassPaymentFacts | null; payment_link?: PassPaymentLinkFacts | null } | undefined;

export const pickPassPayment = (body: { data?: PassRecord | PassRecord[] } | null | undefined): PassPayment => {
  const record = Array.isArray(body?.data) ? body.data[0] : body?.data;
  return { payment: record?.payment ?? null, payment_link: record?.payment_link ?? null };
};

export const usePassPayment = (passId?: string | null, enabled = true) =>
  useQuery({
    queryKey: ['pass-payment', passId],
    queryFn: async () => pickPassPayment(await businessAccessApi<Parameters<typeof pickPassPayment>[0]>({ url: `/${passId}`, method: 'GET', skipGlobalErrorHandling: true })),
    enabled: enabled && !!passId,
    staleTime: 0,
    retry: false,
  });
